/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react';
import { Button, SnapDialog } from '@one-snap/sparkles';
import PropTypes from 'prop-types';
import './LtoTermsPageStyles.css';
import { FormControlLabel, Checkbox } from '@mui/material';
import Footbar from './Footbar';
import CartAmountHeader from './CartAmountHeader';

function LtoTermsPage({
  isVisible,
  onClose,
  totalAmount,
  goBack,
  onContinue,
  isSubmitLoading
}) {
  const [isElectronicConsentChecked, setIsElectronicConsentChecked] =
    useState(true);
  const [isPrivacyNoticeChecked, setIsPrivacyNoticeChecked] = useState(true);
  const [isAuthorizationChecked, setIsAuthorizationChecked] = useState(true);

  const isSubmitEnabled =
    isElectronicConsentChecked &&
    isPrivacyNoticeChecked &&
    isAuthorizationChecked;

  return (
    <SnapDialog
      open={isVisible}
      onClose={onClose}
      className="custom-dialog-sm-width"
    >
      <div className="verification-page-div">
        <CartAmountHeader
          totalAmount={totalAmount}
          goBack={goBack}
          showCartAmount
        />
        <div className="awareness-content">
          <div className="lto-mob-vcode-1">
            Great job! You&apos;re almost done
          </div>
          <FormControlLabel
            control={
              <Checkbox
                className="checkbox-style top-aligned-checkbox"
                name="communicationsOptIn"
              />
            }
            label={
              <div>
                <b>Communications Opt-In.</b> I would like to receive text
              </div>
            }
          />
          <div>
            messages containing offers and updates about Snap’s financial
            products at the telephone number provided (XXX-XXX-XXXX). Message
            frequency will vary. Message and data rates may apply. Reply HELP
            for help or STOP to cancel. I understand that Snap may use an
            automated system to send text messages and make marketing calls to
            the telephone number provided and that I am not required to agree to
            these terms in order to obtain any services from Snap.{' '}
            <a
              href="https://snapfinance.com/legal/sms-terms-and-conditions"
              className="terms-link"
              target="_blank"
              rel="noreferrer"
            >
              <b>
                <u>Snap SMS Terms of Service</u>
              </b>
            </a>
          </div>
          <br />
          <br />
          <br />
          <div className="lto-terms-checkboxes">
            <div className="lto-terms-internal-checkboxes">
              <FormControlLabel
                control={
                  <Checkbox
                    className="checkbox-style top-aligned-checkbox"
                    name="electronicConsent"
                    checked={isElectronicConsentChecked}
                    onChange={(e) =>
                      setIsElectronicConsentChecked(e.target.checked)
                    }
                  />
                }
                label={<div>I have read and understand the </div>}
              />
              <div>
                <a
                  href="https://snapfinance.com/legal/customer-tc#1_consent_to_electronic_transactions"
                  className="terms-link"
                  target="_blank"
                  rel="noreferrer"
                >
                  <b>
                    <u> Consent to Electronic Transactions</u>
                  </b>
                </a>{' '}
                and agree to receive communications and disclosures
                electronically.
              </div>
              <br />
              <FormControlLabel
                control={
                  <Checkbox
                    className="checkbox-style top-aligned-checkbox"
                    name="privacyNotice"
                    checked={isPrivacyNoticeChecked}
                    onChange={(e) =>
                      setIsPrivacyNoticeChecked(e.target.checked)
                    }
                  />
                }
                label={<div>I have read, understand, and consent to: </div>}
              />
              <div>
                <div>
                  <a
                    href="https://snapfinance.com/legal/privacy"
                    className="terms-link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <b>
                      <u>Privacy Notice of Snap Finance LLC</u>
                    </b>
                  </a>
                </div>
                <div>
                  <a
                    href="https://snapfinance.com/legal/customer-tc"
                    className="terms-link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <b>
                      <u>Application Terms and Conditions</u>
                    </b>
                  </a>
                  , including the
                </div>
                <div>
                  <a
                    href="https://snapfinance.com/legal/customer-tc#4_communications_consent"
                    className="terms-link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <b>
                      <u>Communications Consent</u>
                    </b>
                  </a>{' '}
                  and the
                </div>
                <div>
                  <a
                    href="https://snapfinance.com/legal/customer-tc#8_jury_trial_waiver_and_arbitration_clause"
                    className="terms-link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <b>
                      <u>Jury Trial Waiver and Arbitration Clause</u>
                    </b>
                  </a>{' '}
                  , if applicable
                </div>
              </div>
              <br />
              <FormControlLabel
                control={
                  <Checkbox
                    className="checkbox-style top-aligned-checkbox"
                    name="authorization"
                    checked={isAuthorizationChecked}
                    onChange={(e) =>
                      setIsAuthorizationChecked(e.target.checked)
                    }
                  />
                }
                label={
                  <div>I authorize Snap Finance LLC and/or its affiliates</div>
                }
              />
              <div>
                ("Snap") to obtain consumer reports and other information about
                me from consumer reporting agencies and third parties and to use
                that information for any lawful purpose.
              </div>
            </div>
          </div>
          <br />
          <br />
          <br />
          <Button
            className="continue-button"
            onClick={onContinue}
            disabled={!isSubmitEnabled}
            loading={isSubmitLoading}
          >
            Submit Application
          </Button>
          <Footbar />
        </div>
      </div>
    </SnapDialog>
  );
}

LtoTermsPage.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  totalAmount: PropTypes.string.isRequired,
  onContinue: PropTypes.func.isRequired,
  isSubmitLoading: PropTypes.bool.isRequired
};

export default LtoTermsPage;
